// Tooltips and iframeLightbox is now inlined to save on unused javascript.

// From local
import socialShares from './components/social-shares.js';
import twitterTakeaways from './components/twitter-takeaways.js';
import doLazy from './components/lazyload-instance.js';
import postImgDiv from './components/post-image-div.js';
import pillWidth from './components/pill-button-width.js';
import setupWistia from './components/wistia-inject.js';
import footerScripts from './components/footer-scripts.js';
import tableDrag from './components/table-drag.js';
import replaceTableImages from './components/table-image-replace.js';
import caseStudiesNav from './components/case-studies.js';
import doSwiper from './components/swiper.js';
// import animatedHeader from './components/animated-header.js'; PARKED

import './components/wistia-inject.js';
import './components/promo-bar.js';
import './components/gravity-forms.js';
// import './components/homepage-animation.js';
import './components/team-chooser.js';
import './components/rm-review-sites.js';
import './components/toggle-price-rates.js';
import './components/accordion.js';
import './components/pill-section.js';
import './components/content-hubs-nav.js';
import './components/click-to-select.js';
import './components/pricing-tabs.js';
import './components/countdown-timer.js';
import './components/countup.js';
import './components/stat-counter-posts.js';
import './components/login-script.js';
import './components/footer.js';
import './components/helpers.js';
import './components/parallax.js';
import './components/scroll-in-view.js';
import doTippy from './components/tippy.js';



/**
 * On Load
 */
window.onload = function (e) {
    socialShares();
    twitterTakeaways();
    pillWidth();
    //const setupWistia = window['setupWistia'];
    setupWistia(e);
    footerScripts();
    tableDrag();


};

/**
 * On Document ready
 */
function onReady(e) {
    doLazy();
    postImgDiv();
    pillWidth();
    replaceTableImages();
    caseStudiesNav();
    doTippy();
    // animatedHeader(); PARKED

    document.addEventListener("wheel", function (event) {
        if (document.activeElement.type === "number") {
            document.activeElement.blur();
        }
    });
}

if (document.readyState == "interactive") {
    onReady();
} else {
    document.addEventListener("DOMContentLoaded", onReady);
}


